import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { mapProps } from '../../../../../../../util/hocs';
import {
  getCheckoutCart,
  getCheckoutPreviousCart,
} from '../../../../../../../services/checkout/redux/checkoutSelectors';
import RedirectWithStatus from '../../../../../../../components/routing/RedirectWithStatus';
import { CheckoutSuccessModal } from '../../../CheckoutSuccess';
import { openAlert as openAlertAction } from '../../../../../../../actions/modal-actions';
import CheckoutCart from '../../../../../../../services/checkout/components/CheckoutCart/CheckoutCart';

const propTypes = {
  albumMembershipGroupId: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  previousCart: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  client: PropTypes.shape({
    resetStore: PropTypes.func.isRequired,
  }).isRequired,
};

const MembershipsCart = ({
  albumMembershipGroupId,
  cart,
  previousCart,
  client,
}) => {
  const [successModalOpen, setSuccessModalOpen] = useState(false);

  if (!cart.length && !previousCart.length) {
    return (
      <RedirectWithStatus
        status={302}
        to={`/consumer/matches/${albumMembershipGroupId}`}
      />
    );
  }

  return (
    <Fragment>
      <CheckoutCart
        className="memberships-cart-wrap"
        onSuccess={() => {
          // We gotta nuke everything until we can find a way to clear
          // only the relevant data that need clearing (i.e. AlbumMembershipGroup
          // and purchases, purchased custom prints, etc).
          client.resetStore();
          setSuccessModalOpen(true);
        }}
      />

      <CheckoutSuccessModal cart={cart} forceOpen={successModalOpen} />
    </Fragment>
  );
};

MembershipsCart.propTypes = propTypes;

const mapStateToProps = state => ({
  cart: getCheckoutCart(state),
  previousCart: getCheckoutPreviousCart(state),
});

const mapDispatchToProps = {
  openAlert: openAlertAction,
};

export { MembershipsCart as MembershipsCartComponent };

export default compose(
  withRouter,
  withApollo,
  mapProps(({ match, ...props }) => ({
    albumMembershipGroupId: match.params.albumMembershipGroupId,
    ...props,
  })),
  connect(mapStateToProps, mapDispatchToProps),
)(MembershipsCart);
